import { Modal, ModalHeader, ModalBody, ModalFooter, MODAL_SIZES } from 'ui/modal';
import { PanelView } from '../../types';
import { PanelFooter } from './PanelFooter';
import { PanelHeader } from './PanelHeader';
import { PanelBody } from './PanelBody';
import { useCloseModalOverlayContext } from 'modules/creativeLibrary/contexts/CloseModalOverlayContext';
import { CloseModalOverlay } from './components/CloseModalOverlay';
import { PaginationFooter } from './PaginationFooter';

export const testIds = {
  panel: 'cl-panel',
};

export const AssetsAndFoldersCreativeLibraryPanelContent = () => {
  const { showOverlay, setShowOverlay, onCloseModal, onConfirm, panelView } =
    useCloseModalOverlayContext();

  return (
    <Modal
      id="creativeLibraryPanel"
      isModalOpen
      onClose={() => onCloseModal(true)}
      data-test={testIds.panel}
      size={MODAL_SIZES.CLIB}
    >
      <ModalHeader>
        <PanelHeader />
      </ModalHeader>
      <ModalBody size={MODAL_SIZES.CLIB}>
        <PanelBody />
        {showOverlay && (
          <CloseModalOverlay onCancel={() => setShowOverlay(false)} onConfirm={onConfirm} />
        )}
      </ModalBody>

      {panelView === PanelView.List ? (
        <PaginationFooter />
      ) : (
        <ModalFooter hasCancel={false} size={MODAL_SIZES.CLIB}>
          <PanelFooter />
        </ModalFooter>
      )}
    </Modal>
  );
};
